import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "教育进展",
  "lead": "教育照亮通向更美好生活旅程的每一个阶段。所有儿童都需要获得高质量教育的机会，以挖掘他们的学习潜力并使教育产生更广泛的惠益。要特别努力确保所有儿童和青年都能平等受益于教育的变革性力量。这需要有充足的资源，特别是要惠及那些需要更多支持的人。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, PageLink, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scope",
        children: "SCOPE"
      }), _jsxs(_components.p, {
        children: ["教育照亮通向更美好生活旅程的每一个阶段。所有儿童都需要", _jsx(HighlightByTheme, {
          theme: "access",
          children: "获得"
        }), "高", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "质量"
        }), "教育的机会，以挖掘他们的", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "学习"
        }), "潜力并使教育产生更广泛的惠益。要特别努力确保所有儿童和青年都能", _jsx(HighlightByTheme, {
          theme: "equity",
          children: "平等"
        }), "受益于教育的变革性力量。这需要有充足的", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "资源"
        }), "，特别是要惠及那些需要更多支持的人。"]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["2015 年，国际社会将关于教育的", _jsx(_components.a, {
          href: "https://sustainabledevelopment.un.org/sdg4",
          children: "可持续发展目标 4"
        }), "列入到 2030 年要实现的 17 项可持续发展目标中。自那时起，已经制订了一个", _jsx(PageLink, {
          name: "indicators",
          children: "详细的框架"
        }), "，用以监测实现该目标各项具体目标的进展情况。本网站通过五个主题总结了全世界教育领域的关键事实与主要趋势："]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["网站是对《", _jsx(_components.a, {
          href: "https://zh.unesco.org/gem-report/allreports",
          children: "全球教育监测报告"
        }), "》印刷版所提供信息的补充，该报告是国际社会跟踪和审查实现我们的教育目标（可持续发展目标 4）进展情况的工具。"]
      })
    }), "\n", _jsx(LandingButton, {
      children: "开始阅读"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
